import { FC, PropsWithChildren, useReducer } from 'react';

import { InfoContext } from './InfoContext';
import { infoReducer } from './infoReducer';

const UI_INITIAL_STATE = { listMenu: null, title: '' };

export const InfoProvider: FC<PropsWithChildren> = ({ children }) => {
  const [state, dispatch] = useReducer(infoReducer, UI_INITIAL_STATE);

  const setTitle = async (payload: string) => {
    dispatch({ type: '[INFO] - TITLE', payload });
  };

  return (
    <InfoContext.Provider value={{ ...state, setTitle }}>
      {children}
    </InfoContext.Provider>
  );
};
